module.exports = __webpack_public_path__ + "img/a.875930b9.jpg";